export enum ColumnRatio {
    Auto = 'auto',
    Px = 'px',
    LineBreak = '*'
}